// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pZvn5{background-color:#fff;border-radius:.28571429rem}.pZvn5 .EmRTC{text-align:left}.pZvn5 div.TDhA3{align-items:center;display:flex;flex-direction:row;line-height:16px;line-height:1rem;margin-left:-.75rem}.pZvn5 div.TDhA3 strong{margin-left:.75rem;margin-right:.25rem}.pZvn5 div.TDhA3 span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `pZvn5`,
	"editorButton": `EmRTC`,
	"cellValue": `TDhA3`
};
module.exports = ___CSS_LOADER_EXPORT___;
